import React, { PureComponent } from "react";

export const StickyContext = React.createContext({
    subscribe: (handler: ({}: any) => void) => { },
    unsubscribe: (handler: ({}: any) => void) => { },
});

export class StickyContainer extends PureComponent<any, { isScrolling: boolean }> {

    private events = [
        "resize",
        "scroll",
        "pageshow",
    ];

    private node: React.RefObject<HTMLDivElement>;
    private subscribers = [];
    private timer: null | NodeJS.Timeout = null;

    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            isScrolling: false
        };
    }

    subscribe = (handler: ({}: any) => void) => {
        this.subscribers = this.subscribers.concat(handler);
    };

    unsubscribe = (handler: ({}: any) => void) => {
        this.subscribers = this.subscribers.filter(current => current !== handler);
    };

    notifySubscribers = ({ isScrolling }: { isScrolling: boolean }) => {
        const { top, bottom } = this.node.current.getBoundingClientRect();

        const isSticky = top <= 0 && bottom > 0;
    
        const style = (() => {
            if (isScrolling || bottom < 0) {
                return { top: 0, opacity: 0 };
            } else {
                if (isSticky) {
                    return { top: -1 * (top || 0), opacity: 1 };
                } else {
                    return { top: 0, opacity: 1 };
                }
            }
        })();

        this.subscribers.forEach(handler => {
            handler({
                style,
            })
        });
    };

    handleScroll = () => {
        if (!this.state.isScrolling) {
            this.notifySubscribers({ isScrolling: true });
            this.setState({
                isScrolling: true,
            });
        }
        
        if(this.timer !== null) {
            clearTimeout(this.timer);        
        }

        this.timer = setTimeout(() => {
            if (!!this.node.current) {
                this.notifySubscribers({ isScrolling: false });
                this.setState({
                    isScrolling: false,
                });
            }
        }, 120);
    }

    componentDidMount() {
        this.events.forEach(event =>
            window.addEventListener(event, this.handleScroll)
        );
    }

    componentWillUnmount() {
        this.events.forEach(event =>
            window.removeEventListener(event, this.handleScroll)
        );
    }

    render() {
        return (
            <StickyContext.Provider value={{
                subscribe: this.subscribe,
                unsubscribe: this.unsubscribe,
            }}>
                <div
                    {...this.props}
                    ref={this.node}
                />
            </StickyContext.Provider>
        );
    }
}